module.exports = __webpack_public_path__ + "static/media/dashboard-icon.a98b0639.svg";